import React, { useCallback, useContext } from "react";
import * as Sentry from "@sentry/react";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react-lite";
import { UI } from "@wwimmo/ui";
import { Route, selectRoute } from "src/config/routes";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import styles from "./CloseLiveMode.module.css";

const CloseLiveModeBase = observer(() => {
    const { assemblyStore, authStore } = useContext(RootStoreContext);
    const { t } = useTranslation();
    const history = useHistory();

    const onClickStopLiveMode = useCallback(() => {
        assemblyStore.updateAssemblyState(1, t("screens.assemblies.livemode.successfull_closed").toString());

        history.push(
            selectRoute(Route.assemblyDetails, authStore.user?.role, {
                assemblyid: assemblyStore.currentAssembly?.id || ""
            })
        );
    }, [assemblyStore, authStore.user?.role, history, t]);

    return (
        <UI.Card>
            <div className={styles.CardContent}>
                <div className={styles.DivIconCheck}>
                    <UI.Icon icon={UI.SVGIcon.Check} className={styles.IconCheck} size={45} />
                </div>

                <div className={styles.Title}>{t("screens.assemblies.livemode.close")}</div>
                <div className={styles.Text}>{t("screens.assemblies.livemode.close_text")}</div>
                <UI.Button
                    className={styles.ButtonStopLiveMode}
                    label={t("screens.assemblies.livemode.close_button")}
                    onClick={onClickStopLiveMode}
                />
            </div>
        </UI.Card>
    );
});

export const CloseLiveMode = Sentry.withProfiler(CloseLiveModeBase);
